// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Db from "../../backend/Db.bs.jsx";
import * as ReForm from "../../reform/ReForm.bs.jsx";
import * as DialogForm from "../../components/DialogForm/DialogForm.bs.jsx";
import * as Validators from "../../utils/Validators.bs.jsx";
import * as InputWrapper from "../../components/InputWrapper/InputWrapper.bs.jsx";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as FormattedVolume from "../../components/FormattedVolume/FormattedVolume.bs.jsx";
import * as ReForm__Helpers from "../../reform/ReForm__Helpers.bs.jsx";
import * as JsxRuntime from "react/jsx-runtime";

function get(state, field) {
  return state.keg;
}

function set(_state, field, value) {
  return {
    keg: value
  };
}

let FormFields = {
  get: get,
  set: set
};

let Form = ReForm.Make({
  set: set,
  get: get
});

let Validators$1 = Validators.CustomValidators({
  set: set,
  get: get
});

function TapKegOn(props) {
  let onSubmit = props.onSubmit;
  let options = props.untappedChargedKegs.map(keg => ({
    text: <>
      {keg.serialFormatted + ` ` + keg.beer + ` (`}
      <FormattedVolume.make
        milliliters={keg.milliliters}
      />
      {")"}
    </>,
    value: Db.getUid(keg)
  }));
  let form = Form.use({
    keg: Stdlib_Option.getOr(Stdlib_Option.map(options[0], o => o.value), "")
  }, Validators$1.schema([Validators$1.required("Keg")]), param => {
    onSubmit(param.state.values);
  }, undefined, undefined, "OnDemand", undefined);
  return <DialogForm.make
    formId={"tapKegOn"}
    heading={`Narazit pípu: ` + props.tapName}
    onDismiss={props.onDismiss}
    visible={true}
  >
    <Form.Provider.make
      value={form}
    >
      <form
        id={"tapKegOn"}
        onSubmit={ReForm__Helpers.handleSubmit(form.submit)}
      >
        <fieldset
          className={"reset"}
        >
          <Form.Field.make
            field={"Keg"}
            render={field => <InputWrapper.make
              inputName={"keg"}
              inputSlot={<select
                value={field.value}
                onChange={ReForm__Helpers.handleChange(field.handleChange)}
              >
                {options.map(param => {
                  let value = param.value;
                  return <option
                    key={value} 
                    value={value}
                  >
                    {param.text}
                  </option>;
                })}
              </select>}
              labelSlot={"Sud"}
            />}
          />
        </fieldset>
      </form>
    </Form.Provider.make>
  </DialogForm.make>;
}

let make = TapKegOn;

export {
  FormFields,
  Form,
  Validators$1 as Validators,
  make,
}
/* Form Not a pure module */
